import { useState } from "react";

import { pdf } from "@react-pdf/renderer";

import {
  buildShipmentPDFShipment,
  ShipmentPDF,
} from "components/Shipment/components/ShipmentPDF";
import { buildPublicShipmentUrl } from "utils";

interface UsePublicShipmentPDFExportProps {
  shipment: PublicShipment;
}

export function usePublicShipmentPDFExport(
  props: UsePublicShipmentPDFExportProps,
) {
  const { shipment } = props;
  const [isExporting, setIsExporting] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const exportShipmentToPDF = async (
    sections: AppRenderedPDFSectionConfig[],
  ) => {
    setIsExporting(true);
    setError(null);
    try {
      const pdfShipment = buildShipmentPDFShipment(shipment);

      const blob = await pdf(
        <ShipmentPDF
          shipment={pdfShipment}
          sections={sections}
          publicShipmentUrl={buildPublicShipmentUrl(shipment.info.public_token)}
        />,
      ).toBlob();

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `public-shipment-${shipment.info.id}-export.pdf`;
      link.click();

      URL.revokeObjectURL(url);
    } catch (err) {
      setError("Failed to generate PDF. Please try again.");
      throw err;
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportShipmentToPDF,
    isExporting,
    error,
  };
}
